import { getAttachmentUrl } from 'owa-attachment-url';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { ClientAttachmentId } from 'owa-client-ids';
import { AttachmentUrlType } from 'owa-files-url';
import { downloadAttachmentFromUrl } from './downloadAttachmentFromUrl';
import { isCloudyAttachmentType } from 'owa-attachment-model-store/lib/utils/isCloudyAttachment';

export function download(itemId: ClientAttachmentId, attachmentFile: AttachmentType) {
    const downloadUrl = getAttachmentUrl(
        itemId,
        attachmentFile,
        AttachmentUrlType.FullFile,
        isCloudyAttachmentType(attachmentFile),
        false,
        true
    );
    downloadAttachmentFromUrl(downloadUrl, false);
}
